import { IInsertChamSocKhachHangRequest } from "../models/request/cskh/IInsertChamSocKhachHangRequest";
import { ISelectChamSocKhachHangRequest, ISelectCHSKHCSNamRequest } from "../models/request/cskh/ISelectChamSocKhachHangRequest ";
import { ts_chamsockhachhang } from "../models/response/cskh/ts_chamsockhachhang";
import { apiClient } from "./apiClient";

// API Endpoints
export const CHAM_SOC_KHACH_HANG_API_END_POINT = "cskh";

export const chamSocKhachHangApi = {
    select: (data: ISelectChamSocKhachHangRequest) => apiClient.post(`cskh/select`, data),
    detail: (id: number) => apiClient.get(`cskh/${id}`),
    update: (data: ts_chamsockhachhang) => apiClient.put(`cskh`, data),
    insert: (data: IInsertChamSocKhachHangRequest) => apiClient.post(`cskh`, data),
    delete: (id: number) => apiClient.delete(`cskh/${id}`),
    selectAll: () => apiClient.get(`cskh`),
    selectAllByCoSo: (dm_coso_id: number) => apiClient.get(`cskh/select-by-coso/${dm_coso_id}`),
    selectByCoSoNamHoc: (data: ISelectCHSKHCSNamRequest) => apiClient.post(`cskh/select-by-coso-namhoc`, data),
}